import React from 'react';
import '../App.css';


var title = { width: "60%", textAlign:'left', fontSize: "1.8em", marginTop: 80, color:'silver', fontWeight:"200", paddingLeft:70 }
var subTitle = { width: "60%", textAlign:'left', fontSize: "1.3em", marginTop: 20, color:'white', fontWeight:"200", paddingLeft:70, paddingRight:90 }

var windowSize = {
    display:"flex", flexDirection:'column',
    backgroundColor:'black', overflow:'scroll',
    // backgroundImage: "url(../wallpaper.jpg)", backgroundSize:'cover',
    width: "auto", height: "96vh", color: 'white', justifyContent: "start", alignItems:'left',
}

class CGU extends React.Component {
    constructor(props) {
        super(props);    
        this.state = {}
    }

render(){
    return(

        <div style={windowSize}>
            <h1 style={title}>    
            <span style={{color: "rgb(11, 232, 129)" }}>C</span>onditions <span style={{color: "rgb(11, 232, 129)" }}>G</span>énérales d'<span style={{color: "rgb(11, 232, 129)" }}>U</span>tilisation</h1>
            <p style={subTitle}>

            reactstudio est une plateforme d'aide au design de composants React en version Beta. Il s'agit d'un projet d'étude.
            <br />
            <br />

            <strong>Article 1 : Objet</strong>
            <br />
            Les présentes CGU ou Conditions Générales d’Utilisation encadrent juridiquement l’utilisation des services du site reactstudio (ci-après dénommé « le site »).
            Constituant le contrat entre reactstudio et l’Utilisateur. L’accès à cette plateforme signifie l’acceptation des présentes CGU.
            <br/>
            <br />

            <strong>Article 2 : Mentions légales</strong>
            <br />
            Cet outil est développé par @creazerty (Twitter)
            <br/>
            <br />

            <strong>Article 3 : Accès au site</strong>
            <br />
            Le site react studio est accessible gratuitement 
            Pour des raisons de maintenance ou autres, l’accès au site peut être interrompu ou suspendu par l’éditeur sans préavis ni justification.
            <br/>
            <br />

            <strong>Article 4 : Propriété intellectuelle</strong>
            <br />
            Cet outil est développé par @creazerty (Twitter)
            La reproduction et la copie des contenus par l’Utilisateur requièrent une autorisation préalable du site. Dans ce cas, toute utilisation à des usages commerciaux ou à des fins publicitaires est proscrite.
            <br />
            <br />

            <strong>Article 5 : Responsabilité</strong>
            <br />
            Le site a pour finalité d'aider les étudiants développeurs à designer des composants React.
            Bien que les informations publiées sur le site soient réputées fiables, le site se réserve la faculté d’une non-garantie de la fiabilité des ressources.

            Les informations diffusées sur le site reactstudio sont présentées à titre purement informatif et sont sans valeur contractuelle. En dépit des mises à jour régulières, la responsabilité du site ne peut être engagée en cas de modification des dispositions administratives et juridiques apparaissant après la publication. Il en est de même pour l’utilisation et l’interprétation des informations communiquées sur la plateforme.
            Le site décline toute responsabilité concernant les éventuels virus pouvant infecter le matériel informatique de l’Utilisateur après l’utilisation ou l’accès à ce site.

            Le site ne peut être tenu pour responsable en cas de force majeure ou du fait imprévisible et insurmontable d’un tiers.
            Vous demeurez seul résponsable de l'utilisation de l'outil et de l'intégration du code généré par l'outil à déstination de vos applications web.

            La garantie totale de la sécurité et la confidentialité des données n’est pas assurée par le site. 
            <br />
            <br />

            <strong>Article 6 : Liens hypertextes</strong>
            <br />
            Le site peut être constitué de liens hypertextes. En cliquant sur ces derniers, l’Utilisateur sortira de la plateforme. Cette dernière n’a pas de contrôle et ne peut pas être tenue responsable du contenu des pages web relatives à ces liens ni de leurs politiques de confidentialité.
            <br />
            <br />

            <strong>Article 7 : Cookies</strong>
            <br />
            Lors des visites sur le site, l’installation automatique d’un cookie sur le logiciel de navigation de l’Utilisateur peut survenir.

            Les cookies correspondent à de petits fichiers déposés temporairement sur le disque dur de l’ordinateur de l’Utilisateur. Ces cookies sont nécessaires pour assurer l’accessibilité et la navigation sur le site.
            L’information présente dans les cookies est utilisée pour améliorer les performances de navigation sur le site reactstudio.

            En naviguant sur le site, l’Utilisateur accepte les cookies. Leur désactivation peut s’effectuer via les paramètres du logiciel de navigation.
            Le site ne récupère et ne stock aucune donnée.
            Le site peut être constitué de liens hypertextes. En cliquant sur ces derniers, l’Utilisateur sortira de la plateforme. Cette dernière n’a pas de contrôle et ne peut pas être tenue responsable du contenu des pages web relatives à ces liens ni de leurs politiques de confidentialité.
            <br />
            <br />

            <strong>Article 8 : Durée du contrat</strong>
            <br />
            Le présent contrat est valable pour une durée indéterminée. Le début de l’utilisation des services du site marque l’application du contrat à l’égard de l’Utilisateur.
            <br />
            <br />

            <strong>Article 9 : Droit applicable et juridiction compétente</strong>
            <br />
            Le présent contrat est soumis à la législation française.
            <br />
            <br />

            </p>

        </div>
    )
}

}

export default CGU;